interface CampaignUserProps {
  familyName: string;
  givenName: string;
  iamId: string;
}

export class CampaignUser {
  familyName: string;
  givenName: string;
  iamId: string;

  constructor({ familyName, givenName, iamId }: CampaignUserProps) {
    this.familyName = familyName;
    this.givenName = givenName;
    this.iamId = iamId;
  }

  fullName = () => `${this.givenName} ${this.familyName}`;

  static fromDto = ({ familyName, givenName, iamId }: CampaignUserProps): CampaignUser => {
    return new CampaignUser({ familyName, givenName, iamId });
  };
}
